export default __webpack_public_path__ + "static/media/project3.9a2a6ef1.jpg";